import { FC, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import loadingGif from '../../../../assets/gif/loader-ecommander-transparent.gif'
import './lc-loader.scss'

interface Props {
  show?: boolean
  type?: 'small' | 'big'
  message?: string
}

export const LCLoader: FC<Props> = ({ show = false, type = 'big', message }: Props): ReactElement | null => {
  const { t } = useTranslation('e-commander-common', { keyPrefix: 'common' })

  if (!show) {
    return null
  }

  return type === 'big' ? (
    <div>
      <div className="loaderBackground"></div>
      <div className="loaderWrapper">
        <img className="loader-logo" src={loadingGif} alt="logo" />
        <div className="loader-text-wrapper">
          <div className="loader-caption">{t('loading')}</div>
          <div className="loader-wait">{message}</div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="loaderBackground"></div>
      <div className="loader-small">
        <div className="loader-inside">Loading ...</div>
      </div>
    </div>
  )
}
